import { defineStore } from 'pinia';
import { formatHeader } from '@/utils/utils.js';
import StorageHandler from '@/utils/StorageHandler.js';
import FetchData from '@/utils/FetchData.js';
import router from '@/router';

export const useHeaderStore = defineStore('headerStore', {
  state: () => ({
    headers: {
      upper: [],
      lower: [],
      hidden: [],
      View: [],
      userMenu: [],
    },
  }),
  actions: {
    async fetchHeaders(lang) {
      const cachedHeaders = StorageHandler.LoadSessionStorage('headers', 5);
      if (cachedHeaders) {
        this.setHeaders(cachedHeaders);
        this.addDynamicRoutes(cachedHeaders.View);
        return Promise.resolve();
      }

      const config = {
        select: [
          'id',
          'route',
          'parent',
          { value: 'title.' + lang, name: 'title' },
          'View',
          'icon',
          { value: 'title', name: 'BasicTitle' },
          "iframe",
          "access",
          "display_type"
        ],
        orderby: ['parent'],
      };

      try {
        const data = await FetchData(config, 'GetPages', 'POST', true);

        if (!data || !Array.isArray(data)) {
          throw new Error('fetchHeaders: Invalid data format received from FetchData.');
        }

        const processedData = data.map((item) => ({
          ...item,
          title: item.title || item.BasicTitle,
          parent: item.parent || null,
          id: item.id || null,
        }));

        const hiddenHeaders = processedData.filter((item) => item.display_type === 1);
        const upperHeader = processedData.filter((item) => item.display_type === 2);
        const lowerHeader = processedData.filter((item) => item.display_type === 3);
        const userMenu = processedData.filter((item) => item.display_type === 4);
        const Views = processedData.filter((item) => item.View);

        const headers = {
          upper: formatHeader(upperHeader),
          lower: formatHeader(lowerHeader),
          hidden: hiddenHeaders,
          userMenu: userMenu,
          View: Views,
        };
        if (headers.upper && headers.lower && headers.hidden && headers.View && headers.userMenu) {
          StorageHandler.InsertSessionStorage('headers', headers);
        } else {
          console.error("Invalid headers data:", headers);
        }
        this.setHeaders(headers);
        this.addDynamicRoutes(Views);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setHeaders(headers) {
      this.headers.upper = headers.upper || [];
      this.headers.lower = headers.lower || [];
      this.headers.hidden = headers.hidden || [];
      this.headers.View = headers.View || [];
      this.headers.userMenu = headers.userMenu || [];
    },
    addDynamicRoutes(headers) {
      headers.forEach((page) => {
        if (!router.hasRoute(page.title)) {
          let view = page.View + ".vue";
          router.addRoute({
            name: page.title,
            path: page.route,
            meta: { page: page },
            component: () => import('@/views/' + view),
          });
        }
      });
    },
  },
});